<template>
  <div>
    <DashboardHeader title="Print Payslips">
      <iframe :src="pdf" width="100%" height="900"></iframe>
    </DashboardHeader>
  </div>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import pdfMake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMakeParts from "@/plugins/pdfMakeParts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  components: { DashboardHeader },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
  },
  data() {
    return {
      pdf: null,
      pdfNotGenerated: true,
      employeesOnPayroll: [],
    };
  },
  mounted() {
    this.employeesOnPayroll = this.$route.params.employeesOnPayroll;

    this.generatePDF(this);
  },
  methods: {
    generatePDF(vue) {
      const docDefinition = {
        content: vue.getContent(),
        styles: {
          header: {
            fontSize: 28,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 0],
            color: "#2196F3",
          },
          subHeader: {
            fontSize: 22,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 20],
            color: "#2196F3",
          },
          addressSection: {
            alignment: "center",
            margin: [0, 0, 0, 0],
            color: "#000",
          },
          fillColumns: {
            margin: [0, 10, 0, 20],
          },
          tableStyle: {
            margin: [0, 10, 0, 20],
          },
          email: {
            fontSize: 12,
            color: "#2196F3",
            alignment: "center",
            decoration: "underline",
            margin: [0, 0, 0, 20],
          },
        },
      };

      pdfMake.createPdf(docDefinition).getDataUrl((dataUrl) => {
        this.pdf = dataUrl;
      });
    },
    companyHeader() {
      return [
        { text: this.getUserCompany.name, style: ["header"] },
        { text: "Payslip", style: ["subHeader"] },
        {
          text: this.getUserCompany.primary_address,
          style: ["addressSection"],
        },
        {
          text: `${this.getUserCompany.city}, ${this.getUserCompany.postal_code}`,
          style: ["addressSection"],
        },
        { text: this.getUserCompany.primary_phone, style: ["addressSection"] },
        { text: this.getUserCompany.email, style: ["email"] },
      ];
    },
    dateAndPersonalInfo(employee) {
      return {
        style: ["tableStyle"],
        table: {
          widths: ["40%", "*", "*", "40%"],
          body: [
            [
              {
                border: [false, false, false, true],
                fillColor: "#dddddd",
                text: `Name: ${employee.name}`,
              },
              {
                border: [false],
                text: "",
              },
              {
                border: [false],
                text: "",
              },
              {
                border: [false, false, false, true],
                fillColor: "#dddddd",
                text: `Bank: ${employee.bank}`,
              },
            ],
            [
              {
                border: [false, false, false, true],
                fillColor: "#dddddd",
                text: `ID Number: ${employee.id_number}`,
              },
              {
                border: [false],
                text: "",
              },
              {
                border: [false],
                text: "",
              },
              {
                border: [false, false, false, true],
                fillColor: "#dddddd",
                text: `Account #: ${employee.account}`,
              },
            ],
            [
              {
                border: [false, false, false, true],
                fillColor: "#dddddd",
                text: `Address: ${employee.street}. ${employee.city}, ${employee.postal_code}`,
              },
              {
                border: [false],
                text: "",
              },
              {
                border: [false],
                text: "",
              },
              {
                border: [false, false, false, true],
                fillColor: "#dddddd",
                text: `Date: ${employee.payroll_date}`,
              },
            ],
          ],
        },
      };
    },
    itemDetailsTable(employee) {
      const tableObj = {
        style: ["tableStyle"],
        table: {
          widths: ["50%", "50%"],
          body: [
            // Earnings and Deductions Header
            [
              {
                border: [true, true, true, true],
                fillColor: this.getThemeColor,
                color: "white",
                text: "Earnings",
              },
              {
                border: [true, true, true, true],
                fillColor: this.getThemeColor,
                color: "white",
                text: "Deductions",
              },
            ],
            //Earnings and Deductions Details
            [
              {
                table: {
                  widths: ["50%", "50%"],
                  body: [
                    [
                      {
                        border: [false, false, false, false],
                        text: `Basic Salary:`,
                      },
                      {
                        border: [false, false, false, false],
                        text: `${this.getCurrency} ${employee.base_salary}`,
                      },
                    ],
                  ],
                },
              },
              {
                border: [true, true, true, true],
                text: ``,
              },
            ],
            [
              {
                table: {
                  widths: ["50%", "50%"],
                  body: [
                    [
                      {
                        border: [false, false, false, false],
                        text: `Total Hours [${employee.total_hours}]:`,
                      },
                      {
                        border: [false, false, false, false],
                        text: `${this.getCurrency} ${employee.total_rates}`,
                      },
                    ],
                  ],
                },
              },
              {
                border: [true, true, true, true],
                text: ``,
              },
            ],
            this.iterateOverDetails(employee),

            //Totals
            [
              {
                table: {
                  widths: ["50%", "50%"],
                  body: [
                    [
                      {
                        border: [false, false, false, false],
                        fillColor: this.getThemeColor,
                        color: "white",
                        text: `Gross Earnings: `,
                      },
                      {
                        border: [false, false, false, false],
                        fillColor: this.getThemeColor,
                        color: "white",
                        text: `${this.getCurrency} ${employee.gross_earnings}`,
                      },
                    ],
                  ],
                },
              },
              {
                table: {
                  widths: ["50%", "50%"],
                  body: [
                    [
                      {
                        border: [false, false, false, false],
                        fillColor: this.getThemeColor,
                        color: "white",
                        text: `Gross Deductions: `,
                      },
                      {
                        border: [false, false, false, false],
                        fillColor: this.getThemeColor,
                        color: "white",
                        text: `${this.getCurrency} ${employee.gross_deductions}`,
                      },
                    ],
                  ],
                },
              },
            ],
          ],
        },
      };
      return tableObj;
    },
    iterateOverDetails(employee) {
      const details = [{ ul: [] }, { ul: [] }];

      employee.earnings.forEach((earning) => {
        details[0]["ul"].push({
          table: {
            widths: ["50%", "50%"],
            body: [
              [
                {
                  border: [false, false, false, false],
                  text: `${earning.name}`,
                },
                {
                  border: [false, false, false, false],
                  text: `${this.getCurrency} ${earning.amount}`,
                },
              ],
            ],
          },
        });
      });

      employee.deductions.forEach((deduction) => {
        details[1]["ul"].push({
          table: {
            widths: ["50%", "50%"],
            body: [
              [
                {
                  border: [false, false, false, false],
                  text: `${deduction.name}`,
                },
                {
                  border: [false, false, false, false],
                  text: `${this.getCurrency} ${deduction.amount}`,
                },
              ],
            ],
          },
        });
      });

      return details;
    },
    tableTotalsPane(employee) {
      return {
        style: ["tableStyle"],
        table: {
          widths: ["*", "*", 100, 250],
          body: [
            [
              {
                border: [false],
                text: ``,
              },
              {
                border: [false],
                text: "",
              },
              {
                border: [false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fillColor: this.getThemeColor,
                color: "white",
                text: `Computation of Salary Payout`,
              },
            ],
            [
              {
                border: [false],
                text: ``,
              },
              {
                border: [false],
                text: "",
              },
              {
                border: [false],
                text: "",
              },
              {
                table: {
                  widths: ["50%", "50%"],
                  body: [
                    [
                      {
                        border: [false, false, false, false],
                        text: `PAYE Deductions:`,
                      },
                      {
                        border: [false, false, false, false],
                        text: `${this.getCurrency} ${employee.paye}`,
                      },
                    ],
                  ],
                },
              },
            ],
            [
              {
                border: [false],
                text: ``,
              },
              {
                border: [false],
                text: "",
              },
              {
                border: [false],
                text: "",
              },

              {
                table: {
                  widths: ["50%", "50%"],
                  body: [
                    [
                      {
                        border: [false, false, false, false],
                        text: `Net Salary:`,
                      },
                      {
                        border: [false, false, false, false],
                        text: `${this.getCurrency} ${employee.net_salary}`,
                      },
                    ],
                  ],
                },
              },
            ],
          ],
        },
      };
    },
    getContent() {
      const content = [];
      this.employeesOnPayroll.forEach((employee) => {
        content.push([
          pdfMakeParts.companyHeader("PAYSLIP"),
          this.dateAndPersonalInfo(employee),
          this.itemDetailsTable(employee),
          this.tableTotalsPane(employee),
          {
            text: `${this.getUserCompany.name}`,
            alignment: "center",
            pageBreak: "after",
          },
        ]);
      });
      return content;
    },
  },
};
</script>

<style lang="scss" scoped>
.outerBorder {
  border-style: solid;
}
</style>
